const VIEW_USER_RE = /^\/admin\/team\/view-user\/[^/]+$/;
const PROJECT_ROOT_RE = /^\/project\/([^/]+)\/?$/;
const PROJECT_NON_FINANCIALS_RE = /^\/project\/([^/]+)\/(?!financials)[^#?]+/;

export function normalizeChatLink(href: string): string {
	if (VIEW_USER_RE.test(href)) {
		return '/scheduling#people';
	}
	const root = href.match(PROJECT_ROOT_RE);
	if (root) {
		return `/project/${root[1]}/financials#details`;
	}
	const sub = href.match(PROJECT_NON_FINANCIALS_RE);
	if (sub) {
		return `/project/${sub[1]}/financials#details`;
	}
	return href;
}
